import 'uni-pages';import 'uni-h5';import App from './App'


import Vue from 'vue'
import store from './store';
// import mixins from '@/mixins/index.js'
import './styles/index.scss'
import './utils/weapp.socket.io.js'
// 引入uView主JS库
import uView from "uview-ui";
Vue.use(uView);
Vue.config.productionTip = false
Vue.prototype.$store = store
// Vue.mixin(mixins)
App.mpType = 'app'

// 定义全局变量
Vue.prototype.$http = process.env.VUE_APP_HTTP


const app = new Vue({
  ...App,
  store
})
app.$mount()